<template>
  <div id="dlnkdigitasso-adhesion">

    <div class="bg-primary"
         style="background-image: url('/themes/template/img/components/abstract-shapes-20.svg')">
      <div class="container space-1 space-top-lg-2 space-bottom-lg-3">
        <div class="row align-items-center">
          <div class="col">
            <div class="d-none d-md-block mt-4">
              <ul class="step step-centered step-md">
                <li class="step-item">
                  <a href="javascript:" @click="step = 'commencer'">
                    <div class="step-content-wrapper">
                      <span class="step-icon"
                            v-bind:class="(step === 'commencer') ? 'step-icon-primary' : 'step-icon-soft-dark' ">1</span>
                      <div class="step-content">
                        <h4 class="text-white">Commencer</h4>
<!--                        <p class="step-text text-info"-->
<!--                           v-bind:class="(step !== 'commencer') ? 'd-none' : '' ">Informations générales sur votre organisation-->
<!--                        </p>-->
                      </div>
                    </div>
                  </a>
                </li>
                <li class="step-item">
                  <a href="javascript:" @click="step = 'extensions'">
                    <div class="step-content-wrapper">
                      <span class="step-icon"
                            v-bind:class="(step === 'extensions') ? 'step-icon-primary' : 'step-icon-soft-dark' ">2</span>
                      <div class="step-content">
                        <h4 class="text-white">Extensions</h4>
                        <!--                        <p class="step-text text-info"-->
                        <!--                           v-bind:class="(step !== 'extensions') ? 'd-none' : '' ">Informations générales sur votre organisation-->
                        <!--                        </p>-->
                      </div>
                    </div>
                  </a>
                </li>
                <li class="step-item">
                  <a href="javascript:" @click="step = 'profil'">
                    <div class="step-content-wrapper">
                      <span class="step-icon"
                            v-bind:class="(step === 'profil') ? 'step-icon-primary' : 'step-icon-soft-dark' ">3</span>
                      <div class="step-content">
                        <h4 class="text-white">Profil</h4>
                        <!--                        <p class="step-text text-info"-->
                        <!--                           v-bind:class="(step !== 'profil') ? 'd-none' : '' ">Informations générales sur votre organisation-->
                        <!--                        </p>-->
                      </div>
                    </div>
                  </a>
                </li>
                <li class="step-item">
                  <a href="javascript:" @click="step = 'paiement'">
                    <div class="step-content-wrapper">
                      <span class="step-icon"
                            v-bind:class="(step === 'paiement') ? 'step-icon-primary' : 'step-icon-soft-dark' ">4</span>
                      <div class="step-content">
                        <h4 class="text-white">Paiement</h4>
                        <!--                        <p class="step-text text-info"-->
                        <!--                           v-bind:class="(step !== 'paiement') ? 'd-none' : '' ">Informations générales sur votre organisation-->
                        <!--                        </p>-->
                      </div>
                    </div>
                  </a>
                </li>
                <li class="step-item">
                  <a href="javascript:" @click="step = 'message'">
                    <div class="step-content-wrapper">
                      <span class="step-icon"
                            v-bind:class="(step === 'message') ? 'step-icon-primary' : 'step-icon-soft-dark' ">5</span>
                      <div class="step-content">
                        <h4 class="text-white">Message</h4>
                        <!--                        <p class="step-text text-info"-->
                        <!--                           v-bind:class="(step !== 'message') ? 'd-none' : '' ">Informations générales sur votre organisation-->
                        <!--                        </p>-->
                      </div>
                    </div>
                  </a>
                </li>
                <li class="step-item">
                  <a href="javascript:" @click="step = 'personnaliser'">
                    <div class="step-content-wrapper">
                      <span class="step-icon"
                            v-bind:class="(step === 'personnaliser') ? 'step-icon-primary' : 'step-icon-soft-dark' ">5</span>
                      <div class="step-content">
                        <h4 class="text-white">Personnaliser</h4>
                        <!--                        <p class="step-text text-info"-->
                        <!--                           v-bind:class="(step !== 'personnaliser') ? 'd-none' : '' ">Informations générales sur votre organisation-->
                        <!--                        </p>-->
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>


    <form>

      <div v-bind:class="(step === 'commencer') ? '' : 'd-none' "
           class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">
        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3 mb-lg-5">
              <div class="card-header bg-img-hero" style="background-image: url(/themes/template/img/components/abstract-shapes-21.svg);">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0">
                    Avant de commencer
                  </h3>
<!--                  <a href="javascript:" class="btn btn-primary h-100" @click="">Sauvegarder</a>-->
                </div>
              </div>
              <div class="card-body">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="companyNameLabel" class="input-label">Quel est le nom de votre enseigne ?</label>

                  <input type="text" class="form-control" name="companyName" id="companyNameLabel" placeholder="Htmlstream" aria-label="Htmlstream">
                </div>
                <!-- End Form Group -->
              </div>
              <!-- Footer -->
              <div class="card-footer">
                <div class="d-flex justify-content-end align-items-center">
                  <button type="button" class="btn btn-primary" @click="step = 'extensions'">
                    Save and continue <i class="fas fa-angle-right ml-1"></i>
                  </button>
                </div>
              </div>
              <!-- End Footer -->
            </div>
          </div>
        </div>
      </div>

      <div v-bind:class="(step === 'extensions') ? '' : 'd-none' "
           class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">
        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3 mb-lg-5">
              <div class="card-header bg-img-hero" style="background-image: url(/themes/template/img/components/abstract-shapes-21.svg);">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0">
                    Consulter le catalogue
                  </h3>
                  <!--                  <a href="javascript:" class="btn btn-primary h-100" @click="">Sauvegarder</a>-->
                </div>
              </div>
              <div class="card-body">
                <!-- Table -->
                <div class="table-responsive-lg  mx-lg-auto">
                  <table class="table table-striped table-borderless table-hover">
                    <thead class="text-center">
                    <tr>
                      <th scope="col" class="w-40"></th>
                      <th scope="col" class="w-20">
                        <span class="text-dark">Dynamiser</span>
                        <small class="d-block text-body">les liens de votre communauté</small>
                      </th>
                      <th scope="col" class="w-20 border-left border-right">
                        <span class="text-dark">Développer</span>
                        <small class="d-block text-body">les échanges et les partages</small>
                      </th>
                      <th scope="col" class="w-20">
                        <span class="text-dark">Co-créer</span>
                        <small class="d-block text-body">les liens entre initiatives</small>
                      </th>
                    </tr>
                    </thead>
                    <tbody><tr href="#donneesPersonelles" class="border-top border-bottom clickable" data-toggle="collapse" style="cursor: pointer;" aria-expanded="true">
                      <th scope="row" class="text-dark pt-5 pb-3 px-4 mb-0">
                        Données personnelles
                      </th>
                      <td class="text-center p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-20.svg" alt="SVG" style="max-height:40px;">
                      </td>
                      <td class="text-center border-left border-right p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-20.svg" alt="SVG" style="max-height:40px;">
                      </td>
                      <td class="text-center p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-20.svg" alt="SVG" style="max-height:40px;">
                      </td>
                    </tr>

                    </tbody><tbody id="donneesPersonelles" class="panel-collapse collapse " >
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">E-carte</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Mon compte</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Annuaire</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Inscriptions</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Sous-groupes</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  </tbody>

                    <tbody><tr href="#actionsParticipatives" class="border-top border-bottom clickable" data-toggle="collapse" style="cursor: pointer;" aria-expanded="true">
                      <th scope="row" class="text-dark pt-5 pb-3 px-4 mb-0">Actions participatives</th>
                      <td class="text-center p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-7.svg" alt="SVG" style="max-height:40px;">
                      </td>
                      <td class="text-center border-left border-right p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-7.svg" alt="SVG" style="max-height:40px;">
                      </td>
                      <td class="text-center p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-7.svg" alt="SVG" style="max-height:40px;">
                      </td>
                    </tr></tbody><tbody id="actionsParticipatives" class="panel-collapse collapse " >
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Chat privé</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Forum</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Idées</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Votes</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Sondages</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Évènements</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Fidélisation</th>
                    <td class="text-center p-3">
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Transfert de docs</th>
                    <td class="text-center text-body p-3">
                    </td>
                    <td class="text-center text-body border-left border-right py-3 px-4"></td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Partage de cours</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Transfert de fichiers</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  </tbody>
                    <tbody><tr href="#siteIntranet" class="border-top border-bottom clickable" data-toggle="collapse" style="cursor: pointer;" aria-expanded="true">
                      <th scope="row" class="text-dark pt-5 pb-3 px-4 mb-0">Site intranet</th>
                      <td class="text-center p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-40.svg" alt="SVG" style="max-height:40px;">
                      </td>
                      <td class="text-center border-left border-right p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-40.svg" alt="SVG" style="max-height:40px;">
                      </td>
                      <td class="text-center p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-40.svg" alt="SVG" style="max-height:40px;">
                      </td>
                    </tr><tr>
                    </tr></tbody><tbody id="siteIntranet" class="panel-collapse collapse " >
                  <tr><th scope="row" class="font-size-1 py-3 px-4">Carrousel</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                    </td>
                    <td class="text-center p-3">
                    </td>
                  </tr><tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Actualités</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                    </td>
                    <td class="text-center p-3">
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Galerie photos et vidéos</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                    </td>
                    <td class="text-center p-3">
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Librairie</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Blog</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                    </td>
                    <td class="text-center p-3">
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Affichage des partenaires</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                    </td>
                  </tr>
                  </tbody>
                    <tbody><tr href="#transactions" class="border-top border-bottom clickable" data-toggle="collapse" style="cursor: pointer;" aria-expanded="true">
                      <th scope="row" class="text-dark pt-5 pb-3 px-4 mb-0">Transactions</th>
                      <td class="text-center p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-34.svg" alt="SVG" style="max-height:40px;">
                      </td>
                      <td class="text-center border-left border-right p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-34.svg" alt="SVG" style="max-height:40px;">
                      </td>
                      <td class="text-center p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-34.svg" alt="SVG" style="max-height:40px;">
                      </td>
                    </tr>
                    </tbody><tbody id="transactions" class="panel-collapse collapse" >
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Ma boutique</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Adhésions</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                    </td>
                    <td class="text-center p-3">
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Dons</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                    </td>
                    <td class="text-center p-3">
                    </td>
                  </tr>

                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Cagnottes</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                    </td>
                  </tr>
                  </tbody>

                    <tbody><tr href="#pilotage" class="border-top border-bottom clickable" data-toggle="collapse" style="cursor: pointer;" aria-expanded="true">
                      <th scope="row" class="text-dark pt-5 pb-3 px-4 mb-0">Pilotage</th>
                      <td class="text-center p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-35.svg" alt="SVG" style="max-height:40px;">
                      </td>
                      <td class="text-center border-left border-right p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-35.svg" alt="SVG" style="max-height:40px;">
                      </td>
                      <td class="text-center p-3">
                        <img class="img-fluid" src="/themes/template/img/icons/icon-35.svg" alt="SVG" style="max-height:40px;">
                      </td>
                    </tr>

                    </tbody><tbody id="pilotage" class="panel-collapse collapse">
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Compte administration</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Gestion de projet</th>
                    <td class="text-center text-body p-3"></td>
                    <td class="text-center text-body border-left border-right p-3">
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr><tr>
                    <th scope="row" class="font-size-1 py-3 px-4">Pilotage et gestion des KPI</th>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center border-left border-right p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                    <td class="text-center p-3">
                      <i class="fas fa-check-circle text-success mr-2"></i>
                    </td>
                  </tr>
                  </tbody>


                  </table>
                </div>
                <!-- End Table -->
              </div>
              <div class="card-footer">
                <div class="d-flex align-items-center">
                  <button type="button" class="btn btn-ghost-secondary" @click="step = 'commencer'">
                    <i class="fas fa-angle-left mr-1"></i> Previous step
                  </button>

                  <div class="ml-auto">
                    <button type="button" class="btn btn-primary" @click="step = 'profil'">
                      Save and continue <i class="fas fa-angle-right ml-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-bind:class="(step === 'profil') ? '' : 'd-none' "
           class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">
        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3 mb-lg-5">
              <div class="card-header bg-img-hero" style="background-image: url(/themes/template/img/components/abstract-shapes-21.svg);">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0">
                    Informations complémentaires
                  </h3>
                  <!--                  <a href="javascript:" class="btn btn-primary h-100" @click="">Sauvegarder</a>-->
                </div>
              </div>
              <div class="card-body">


                <div class="mb-3">
                  <label for="name-school" class=" col-form-label input-label">Nom de l'établissement</label>
                  <input type="text" class="form-control" name="firstName" id="name-school" placeholder="" aria-label="" value="">


                </div>

                <!-- Form Group -->
                <div class="js-form-message form-group">
                  <label class="input-label" for="signinSrEmailExample1">Code UAI</label>
                  <input type="email" class="form-control" name="email" id="signinSrEmailExample1" placeholder="Email address" aria-label="Email address" required
                         data-msg="Please enter a valid email address.">
                </div>
                <!-- End Form Group -->

                <!-- Form Group -->
                <div class="js-form-message form-group">
                  <label class="input-label" for="signinSrEmailExample2">Adresse e-mail de l'établissement</label>
                  <input type="email" class="form-control" name="email" id="signinSrEmailExample2" placeholder="Email address" aria-label="Email address" required
                         data-msg="Please enter a valid email address.">
                </div>
                <!-- End Form Group -->

                <!-- Form Group -->
                <div class="form-group">
                  <label class=" col-form-label input-label">Logo de l'école</label>
                  <div class="col-sm-9">
                    <div class="media align-items-center">
                      <label class="avatar avatar-xl avatar-circle mr-4" for="avatarUploader">
                        <img id="avatarImg" class="avatar-img" src="/modules/testmaquette/img/digitasso/lecorbusier.png" alt="Image Description">
                      </label>

                      <div class="media-body">
                        <div class="btn btn-sm btn-primary file-attachment-btn mb-2 mb-sm-0 mr-2">Télécharger une photo
                          <input type="file" class="js-file-attach file-attachment-btn-label" id="avatarUploader"
                                 data-hs-file-attach-options='{
                          "textTarget": "#avatarImg",
                          "mode": "image",
                          "targetAttr": "src",
                          "allowTypes": [".png", ".jpeg", ".jpg"]
                       }'>
                        </div>

                        <a class="btn btn-sm btn-white mb-2 mb-sm-0" href="javascript:;">Supprimer</a>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Form Group -->

                <!-- Form Group -->
                <div class="js-form-message form-group">
                  <label class="input-label" for="signinSrPasswordExample1">Mot de passe</label>
                  <input type="password" class="form-control" name="password" id="signinSrPasswordExample1" placeholder="********" aria-label="********" required
                         data-msg="Your password is invalid. Please try again.">
                </div>
                <!-- End Form Group -->

                <!-- Form Group -->
                <div class="js-form-message form-group">
                  <label class="input-label" for="signinSrConfirmPassword">Confirmer votre mot de passe</label>
                  <input type="password" class="form-control" name="confirmPassword" id="signinSrConfirmPassword" placeholder="********" aria-label="********" required
                         data-msg="Password does not match the confirm password.">
                </div>
                <!-- End Form Group -->

              </div>
              <div class="card-footer">
                <div class="d-flex align-items-center">
                  <button type="button" class="btn btn-ghost-secondary" @click="step = 'extensions'">
                    <i class="fas fa-angle-left mr-1"></i> Previous step
                  </button>

                  <div class="ml-auto">
                    <button type="button" class="btn btn-primary" @click="step = 'paiement'">
                      Save and continue <i class="fas fa-angle-right ml-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-bind:class="(step === 'paiement') ? '' : 'd-none' "
           class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">
        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3 mb-lg-5">
              <div class="card-header bg-img-hero" style="background-image: url(/themes/template/img/components/abstract-shapes-21.svg);">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0">
                    Paiement
                  </h3>
                  <!--                  <a href="javascript:" class="btn btn-primary h-100" @click="">Sauvegarder</a>-->
                </div>
              </div>
              <div class="card-body">
                <!-- Form Group -->
                <div class="form-group">
                  <label class="input-label">Montant de l'adhésion</label>
                  <p class="form-control">50,00 €</p>
                </div>
                <!-- End Form Group -->

                <!-- Form Group -->
                <div class="form-group">
                  <label for="numero_iban" class="input-label">IBAN</label>
                  <input type="email" class="form-control" name="numero_iban" id="numero_iban" placeholder="000-000-000-00000" aria-label="IBAN">
                </div>
                <!-- End Form Group -->

                <div class="row">
                  <div class="col-sm-6">
                    <!-- Form Group -->
                    <div class="form-group">
                      <label for="bicc" class="input-label">Code BIC</label>
                      <input type="text" class="form-control"  name="bicc" id="bicc" placeholder="AGRIFRPP 000" aria-label="bic">
                    </div>
                    <!-- End Form Group -->
                  </div>
                  <div class="col-sm-6">
                    <!-- Form Group -->
                    <div class="form-group">
                      <label for="titulaire_name" class="input-label">Nom du titulaire</label>
                      <input type="text" class="form-control" name="titulaire_name" id="titulaire_name" placeholder="nom" aria-label="titulaire_name">
                    </div>
                    <!-- End Form Group -->
                  </div>


                </div>
                <!-- End Row -->




              </div>
              <div class="card-footer">
                <div class="d-flex align-items-center">
                  <button type="button" class="btn btn-ghost-secondary" @click="step = 'profil'">
                    <i class="fas fa-angle-left mr-1"></i> Previous step
                  </button>

                  <div class="ml-auto">
                    <button type="button" class="btn btn-primary" @click="step = 'message'">
                      Save and continue <i class="fas fa-angle-right ml-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-bind:class="(step === 'message') ? '' : 'd-none' "
           class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">
        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3 mb-lg-5">
              <div class="card-header bg-img-hero" style="background-image: url(/themes/template/img/components/abstract-shapes-21.svg);">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0">
                    Générer un message de bienvenue
                  </h3>
                  <!--                  <a href="javascript:" class="btn btn-primary h-100" @click="">Sauvegarder</a>-->
                </div>
              </div>
              <div class="card-body">
                <!-- Form Group -->
                <div class="form-group">
                  <label class="input-label">Describe the responsibilities of this job, required work experience, skills, or education.</label>

                  <div class="mb-3">
                    <a href="javascript:;" data-toggle="modal" data-target="#uploadFilesModal">Upload a .pdf or .docx</a>
                  </div>

                  <textarea class="col-12" rows="8"></textarea>

                  <!-- Quill -->
<!--                  <div class="quill-custom">-->
<!--                    <div class="js-quill" style="min-height: 15rem;"-->
<!--                         data-hs-quill-options='{-->
<!--                 "placeholder": "Type your message...",-->
<!--                  "modules": {-->
<!--                    "toolbar": [-->
<!--                      ["bold", "italic", "underline", "strike", "link", "image", "blockquote", "code"]-->
<!--                    ]-->
<!--                  }-->
<!--                 }'>-->
<!--                    </div>-->
<!--                  </div>-->
                  <!-- End Quill -->
                </div>
                <!-- End Form Group -->

                <!-- Form Group -->
                <div class="form-group">
                  <label class="input-label">Include COVID-19 precautions <span class="badge badge-soft-dark ml-1">Important to job seekers</span></label>
                  <p class="small mt-n2">We'll save this information to make posting faster in the future.</p>

                  <!-- Custom Radio -->
                  <div class="form-control mb-2">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" name="covid19PrecautionsCheckboxName" id="covid19PrecautionsCheckbox1">
                      <label class="custom-control-label" for="covid19PrecautionsCheckbox1">Remote interview process</label>
                    </div>
                  </div>
                  <!-- End Custom Radio -->

                  <!-- Custom Radio -->
                  <div class="form-control mb-2">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" name="covid19PrecautionsCheckboxName" id="covid19PrecautionsCheckbox2">
                      <label class="custom-control-label" for="covid19PrecautionsCheckbox2">Personal protective equipment provided or required</label>
                    </div>
                  </div>
                  <!-- End Custom Radio -->

                  <!-- Custom Radio -->
                  <div class="form-control mb-2">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" name="covid19PrecautionsCheckboxName" id="covid19PrecautionsCheckbox3">
                      <label class="custom-control-label" for="covid19PrecautionsCheckbox3">Plastic shield at work stations</label>
                    </div>
                  </div>
                  <!-- End Custom Radio -->

                  <!-- Custom Radio -->
                  <div class="form-control mb-2">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" name="covid19PrecautionsCheckboxName" id="covid19PrecautionsCheckbox4">
                      <label class="custom-control-label" for="covid19PrecautionsCheckbox4">Temperature screenings</label>
                    </div>
                  </div>
                  <!-- End Custom Radio -->

                  <!-- Custom Radio -->
                  <div class="form-control mb-2">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" name="covid19PrecautionsCheckboxName" id="covid19PrecautionsCheckbox5">
                      <label class="custom-control-label" for="covid19PrecautionsCheckbox5">Social distancing guidelines in place</label>
                    </div>
                  </div>
                  <!-- End Custom Radio -->

                  <!-- Custom Radio -->
                  <div class="form-control mb-2">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" name="covid19PrecautionsCheckboxName" id="covid19PrecautionsCheckbox6">
                      <label class="custom-control-label" for="covid19PrecautionsCheckbox6">Virtual meetings</label>
                    </div>
                  </div>
                  <!-- End Custom Radio -->

                  <!-- Custom Radio -->
                  <div class="form-control mb-2">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" name="covid19PrecautionsCheckboxName" id="covid19PrecautionsCheckbox7">
                      <label class="custom-control-label" for="covid19PrecautionsCheckbox7">Sanitizing, disinfecting, or cleaning procedures in place</label>
                    </div>
                  </div>
                  <!-- End Custom Radio -->
                </div>
                <!-- End Form Group -->

                <!-- Form Group -->
                <div class="form-group">
                  <div class="row mb-2">
                    <div class="col">
                      <label for="additionalCovid19PrecautionsLabel" class="input-label">Are you taking any additional COVID-19 precautions?</label>
                      <p class="small mt-n2 mb-0">Let job seekers know how you’re responding to COVID-19.</p>
                    </div>

                    <div class="col-auto align-self-end">
                      <span id="additionalCovid19PrecautionsCountCharacters" class="text-muted"></span>
                    </div>
                  </div>
                  <!-- End Row -->

                  <textarea id="additionalCovid19PrecautionsLabel" class="js-count-characters form-control" placeholder="Ex: All customers are required to wear a mask, curbside pickup available, common surfaces are sanitized regularly, etc." aria-label="Ex: All customers are required to wear a mask, curbside pickup available, common surfaces are sanitized regularly, etc." rows="4" maxlength="250"
                            data-hs-count-characters-options='{
                      "output": "#additionalCovid19PrecautionsCountCharacters"
                    }'></textarea>
                </div>
                <!-- End Form Group -->
              </div>
              <div class="card-footer">
                <div class="d-flex align-items-center">
                  <button type="button" class="btn btn-ghost-secondary" @click="step = 'paiement'">
                    <i class="fas fa-angle-left mr-1"></i> Previous step
                  </button>

                  <div class="ml-auto">
                    <button type="button" class="btn btn-primary" @click="step = 'personnaliser'">
                      Save and continue <i class="fas fa-angle-right ml-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-bind:class="(step === 'personnaliser') ? '' : 'd-none' "
           class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">
        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3 mb-lg-5">
              <div class="card-header bg-img-hero" style="background-image: url(/themes/template/img/components/abstract-shapes-21.svg);">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0">
                    Application settings
                  </h3>
                  <!--                  <a href="javascript:" class="btn btn-primary h-100" @click="">Sauvegarder</a>-->
                </div>
              </div>
              <div class="card-body">
                <!-- Form Group -->
                <div class="form-group">
                  <label class="input-label">How do you want to receive applications? <i class="far fa-question-circle" data-toggle="tooltip" data-placement="top" title="Email: Screen candidates individually, received by email. In person: We source and send candidates directly to you."></i></label>

                  <!-- Button Group -->
                  <div class="btn-group btn-group-toggle btn-group-segment d-flex" data-toggle="buttons">
                    <label class="btn flex-fill active">
                      <input type="checkbox" name="receiveApplicationsName" id="receiveApplicationsOption1" checked> Email
                    </label>
                    <label class="btn flex-fill">
                      <input type="checkbox" name="receiveApplicationsName" id="receiveApplicationsOption2"> Phone
                    </label>
                    <label class="btn flex-fill">
                      <input type="checkbox" name="receiveApplicationsName" id="receiveApplicationsOption3"> In-person
                    </label>
                  </div>
                  <!-- End Button Group -->
                </div>
                <!-- End Form Group -->

                <!-- Form Group -->
                <div class="form-group">
                  <label class="input-label">Do you want applicants to submit a resume?</label>

                  <!-- Button Group -->
                  <div class="btn-group btn-group-toggle btn-group-segment d-flex" data-toggle="buttons">
                    <label class="btn flex-fill active">
                      <input type="checkbox" name="submitApplicationsName" id="submitApplicationsOption1" checked> Yes
                    </label>
                    <label class="btn flex-fill">
                      <input type="checkbox" name="submitApplicationsName" id="submitApplicationsOption2"> No
                    </label>
                    <label class="btn flex-fill">
                      <input type="checkbox" name="submitApplicationsName" id="submitApplicationsOption3"> Optional
                    </label>
                  </div>
                  <!-- End Button Group -->
                </div>
                <!-- End Form Group -->

                <!-- Form Group -->
                <div class="form-group">
                  <label for="canditateApplicationsSentToEmailNameLabel" class="input-label">Daily updates about this job and candidates will be sent to:</label>

                  <input type="email" class="form-control" name="canditateApplicationsSentToEmailName" id="canditateApplicationsSentToEmailNameLabel" placeholder="example@gmail.com" aria-label="example@gmail.com">
                </div>
                <!-- End Form Group -->

                <!-- Form Group -->
                <div class="form-group">
                  <label for="sendEmailUpdatesCheckbox" class="input-label">Daily updates about this job and candidates will be sent to:</label>

                  <!-- Custom Checkbox -->
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="sendEmailUpdatesCheckbox" checked>
                    <label class="custom-control-label" for="sendEmailUpdatesCheckbox">Also send an individual email update every time a new candidate applies</label>
                  </div>
                  <!-- End Custom Checkbox -->
                </div>
                <!-- End Form Group -->
              </div>
              <div class="card-footer">
                <div class="d-flex align-items-center">
                  <button type="button" class="btn btn-ghost-secondary" @click="step = 'message'">
                    <i class="fas fa-angle-left mr-1"></i> Previous step
                  </button>

                  <div class="ml-auto">
                    <button type="button" class="btn btn-primary">
                      Valider et créer un compte <i class="fas fa-angle-right ml-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "DlnkDigitassoAdhesion",
  data: function () {
    return {
      step: "commencer",
    }
  }
}
</script>

<style scoped>

</style>